<template>
  <div class="p-4 rounded ring-1 ring-gray-30 bg-gray-10 relative flex flex-col self-baseline">
    <div class="content-box">
      <collapsible-article :line-num="3" :is-collapse-btn-shown="true" :min-container-height="136" :min-content-height="92">
        <coupon-title class="mb-3" :title="props.item.title!" />
        <p class="whitespace-pre-line">{{ props.item.content }}</p>
        <p v-if="props.item.condition" class="mt-1 whitespace-pre-line">{{ $t('promo.apply_condition', { condition: props.item.condition }) }}</p>
      </collapsible-article>
    </div>
    <coupon-divider />
    <div class="bottom-section flex items-center justify-between min-h-15 gap-2">
      <div class="text-sm">
        <div v-if="props.item.usage_rate" class="text-gray-80">{{ props.item.usage_rate }}</div>
        <coupon-deadline :end-at="props.item.end_at!" />
        <coupon-used-times :redeemedTimes="props.item.times!" :remainTimes="props.item.remain_times!" />
      </div>
      <!-- <etg-button v-if="props.item.path" :to="props.item.path" type="primary" :size="btnSize">{{ $t('promo.button.apply') }}</etg-button> -->
    </div>
  </div>
</template>

<script setup lang="ts">
import CollapsibleArticle from '@/components/common/collapsible-article.vue'
import CouponTitle from '@/components/member/coupons/coupon-title.vue'
import CouponDivider from '@/components/member/coupons/coupon-divider.vue'
import CouponDeadline from '@/components/member/coupons/coupon-deadline.vue'
import CouponUsedTimes from '@/components/member/coupons/coupon-used-times.vue'

// import { useAppStore } from '@/store/app'
import type { FpromoMemberPromoCode } from '@/types/api'

interface Props {
  item: FpromoMemberPromoCode
}

const props = defineProps<Props>()

// const appStore = useAppStore()

// const btnSize = computed(() => (appStore.isMobileScreen ? 'small' : 'medium'))
</script>

<style lang="scss" scoped>
.content-box :deep(.read-more) {
  @apply pt-3;
}
</style>
